import { Box } from '@mui/material';

import { HighlightLabelProps } from './types';

export type { HighlightLabelProps } from './types';

export const HighlightLabel = ({ query, children }: HighlightLabelProps) => {
  const text = typeof children === 'string' ? children : String(children ?? '');

  if (!query) return <span>{text}</span>;

  const parts = text.split(new RegExp(`(${query})`, 'gi'));

  return (
    <span>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <Box
            key={i}
            component="mark"
            sx={{
              color: 'inherit',
              bgcolor: 'rgba(var(--mui-palette-primary-mainChannel) / 0.4)',
            }}
          >
            {part}
          </Box>
        ) : (
          part
        )
      )}
    </span>
  );
};
